import { isFeatureEnabled } from 'owa-feature-flags';

export function isBizchatContextDisabled(): boolean | undefined {
    // For now, we are only checking the feature flag used for testing
    // TODO: check OCSP policy when ready and make multiaccount aware
    return isFeatureEnabled('mon-copilot-bizchat-context-disabled');
}
